import React from "react";
import "./AuthLayout.css"; // Import the CSS file
import Logo from "../../assets/Images/witmeg-logo.svg";
import AppVersionFooter from "../../components/common/AppVersionFooter";

const AuthLayout = ({ children, leftWidth = "50%" }) => {
  return (
    <div className="auth-container" style={{ "--left-width": leftWidth }}>
      {/* Left Side - Form Section */}
      <div className="auth-left">
        <div className="auth-content">{children}</div>
        {/* The version line, on the form side rather than across the whole window - the
            right half is a full-bleed image and a grey bar over it would read as a seam.
            One mount here covers login, forgotten password, OTP and new password, which
            all render through this layout. */}
        {/* <AppVersionFooter className="avf-bar--auth" /> */}
      </div>

      {/* Right Side - Image Section */}
      <div className="auth-right">
        <div className="auth-image">
          <div className="witmeg-logo">
            <img src={Logo} alt="witmeg-logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
